import { Injectable, inject } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';
import { TranslocoService } from '@jsverse/transloco';

const BRAND = 'SmartLink';

@Injectable({ providedIn: 'root' })
export class AppTitleStrategy extends TitleStrategy {
  private readonly title = inject(Title);
  private readonly transloco = inject(TranslocoService);
  private currentKey: string | null = null;

  constructor() {
    super();
    this.transloco.langChanges$.subscribe(() => this.applyTitle());
    this.transloco.events$.subscribe((event) => {
      if (event.type === 'translationLoadSuccess') this.applyTitle();
    });
  }

  override updateTitle(snapshot: RouterStateSnapshot): void {
    this.currentKey = this.buildTitle(snapshot) ?? null;
    this.applyTitle();
  }

  private applyTitle(): void {
    if (!this.currentKey) {
      this.title.setTitle(BRAND);
      return;
    }
    const translated = this.transloco.translate(this.currentKey);
    this.title.setTitle(`${translated} | ${BRAND}`);
  }
}
